import React, { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { Button, Collapse } from "antd";
import { TokenVerificationLoggedin, BlockAdmin, BlockAM } from "../../utils/tokenVerify"
import axios from "axios";
import Cookies from "js-cookie";
import configData from "../../config/config.json";
import { notifyfailure } from "../../utils/toast";
import FullLoader from "../../assets/images/full-page-loader.gif"
// import knowledgeBaseData from "./knowledgeBaseData.json"; // Commented out: data now comes from API

// ─── Icon Components ────────────────────────────────────────────────────────────
const AuctionEligibilityIcon = ({ color = "currentColor" }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
        <path d="M8.45879 7.29175L3.79212 11.9584C3.56006 12.1905 3.24531 12.3209 2.91712 12.3209C2.58894 12.3209 2.27419 12.1905 2.04212 11.9584C1.81006 11.7264 1.67969 11.4116 1.67969 11.0834C1.67969 10.7552 1.81006 10.4405 2.04212 10.2084L6.70879 5.54175" stroke={color} strokeWidth="1.16667" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M9.33301 9.33325L12.833 5.83325" stroke={color} strokeWidth="1.16667" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M4.66699 4.66675L8.16699 1.16675" stroke={color} strokeWidth="1.16667" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M5.25 4.08325L9.91667 8.74992" stroke={color} strokeWidth="1.16667" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M12.2497 6.41667L7.58301 1.75" stroke={color} strokeWidth="1.16667" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

const BidRequestValidityIcon = ({ color = "currentColor" }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
        <path d="M2.2457 5.02831C2.16056 4.64478 2.17363 4.24597 2.28371 3.86884C2.39379 3.49171 2.5973 3.14849 2.87539 2.87098C3.15348 2.59347 3.49713 2.39068 3.87449 2.28139C4.25185 2.1721 4.65069 2.15986 5.03403 2.24581C5.24503 1.91582 5.5357 1.64425 5.87926 1.45614C6.22281 1.26803 6.60819 1.16943 6.99987 1.16943C7.39155 1.16943 7.77693 1.26803 8.12048 1.45614C8.46403 1.64425 8.7547 1.91582 8.9657 2.24581C9.34963 2.15949 9.74916 2.17167 10.1271 2.28123C10.5051 2.39078 10.8492 2.59414 11.1274 2.8724C11.4057 3.15066 11.6091 3.49477 11.7186 3.87273C11.8282 4.25068 11.8404 4.65021 11.754 5.03414C12.084 5.24514 12.3556 5.53581 12.5437 5.87936C12.7318 6.22292 12.8304 6.60829 12.8304 6.99998C12.8304 7.39166 12.7318 7.77703 12.5437 8.12059C12.3556 8.46414 12.084 8.75481 11.754 8.96581C11.84 9.34916 11.8277 9.748 11.7185 10.1254C11.6092 10.5027 11.4064 10.8464 11.1289 11.1245C10.8514 11.4025 10.5081 11.6061 10.131 11.7161C9.75388 11.8262 9.35506 11.8393 8.97153 11.7541C8.76081 12.0854 8.46991 12.3581 8.12577 12.5471C7.78164 12.736 7.39538 12.8351 7.00278 12.8351C6.61019 12.8351 6.22393 12.736 5.87979 12.5471C5.53566 12.3581 5.24476 12.0854 5.03403 11.7541C4.65069 11.8401 4.25185 11.8278 3.87449 11.7186C3.49713 11.6093 3.15348 11.4065 2.87539 11.129C2.5973 10.8515 2.39379 10.5082 2.28371 10.1311C2.17363 9.75398 2.16056 9.35517 2.2457 8.97164C1.91318 8.7612 1.63928 8.47008 1.44948 8.12535C1.25968 7.78062 1.16016 7.3935 1.16016 6.99998C1.16016 6.60645 1.25968 6.21933 1.44948 5.8746C1.63928 5.52987 1.91318 5.23875 2.2457 5.02831Z" stroke={color} strokeWidth="1.16667" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M5.25 6.99992L6.41667 8.16659L8.75 5.83325" stroke={color} strokeWidth="1.16667" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

const MonetizationReadinessIcon = ({ color = "currentColor" }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
        <path d="M11.6663 7.58343C11.6663 10.5001 9.62467 11.9584 7.19801 12.8043C7.07094 12.8473 6.9329 12.8453 6.80717 12.7984C4.37467 11.9584 2.33301 10.5001 2.33301 7.58343V3.5001C2.33301 3.34539 2.39447 3.19702 2.50386 3.08762C2.61326 2.97822 2.76163 2.91677 2.91634 2.91677C4.08301 2.91677 5.54134 2.21677 6.55634 1.3301C6.67992 1.22452 6.83713 1.1665 6.99967 1.1665C7.16222 1.1665 7.31943 1.22452 7.44301 1.3301C8.46384 2.2226 9.91634 2.91677 11.083 2.91677C11.2377 2.91677 11.3861 2.97822 11.4955 3.08762C11.6049 3.19702 11.6663 3.34539 11.6663 3.5001V7.58343Z" stroke={color} strokeWidth="1.16667" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M5.25 6.99992L6.41667 8.16659L8.75 5.83325" stroke={color} strokeWidth="1.16667" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

const OptimizationSignalsIcon = ({ color = "currentColor" }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
        <path d="M10.5 11.6666V5.83325" stroke={color} strokeWidth="1.16667" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M7 11.6666V2.33325" stroke={color} strokeWidth="1.16667" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M3.5 11.6667V8.16675" stroke={color} strokeWidth="1.16667" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

const OptionalEnhancementsIcon = ({ color = "currentColor" }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
        <path d="M7.00033 12.8334C10.222 12.8334 12.8337 10.2217 12.8337 7.00008C12.8337 3.77842 10.222 1.16675 7.00033 1.16675C3.77866 1.16675 1.16699 3.77842 1.16699 7.00008C1.16699 10.2217 3.77866 12.8334 7.00033 12.8334Z" stroke={color} strokeWidth="1.16667" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M12.8333 7H10.5" stroke={color} strokeWidth="1.16667" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M3.50033 7H1.16699" stroke={color} strokeWidth="1.16667" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M7 3.50008V1.16675" stroke={color} strokeWidth="1.16667" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M7 12.8333V10.5" stroke={color} strokeWidth="1.16667" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

const DeviceIcon = ({ color = "currentColor" }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
        <path d="M9.91699 1.16675H4.08366C3.37331 1.16675 2.79199 1.74807 2.79199 2.45841V11.5417C2.79199 12.2521 3.37331 12.8334 4.08366 12.8334H9.91699C10.6273 12.8334 11.2087 12.2521 11.2087 11.5417V2.45841C11.2087 1.74807 10.6273 1.16675 9.91699 1.16675Z" stroke={color} strokeWidth="1.16667" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M7 10.5H7.00583" stroke={color} strokeWidth="1.16667" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

const CriteriaTypeIcon = ({ color = "currentColor" }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
        <path d="M7 1.16675V7.00008L9.91667 9.91675" stroke={color} strokeWidth="1.16667" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M2.04199 4.95841C2.55783 3.89258 3.38574 3.00782 4.41699 2.41683C5.44824 1.82584 6.63491 1.55371 7.82308 1.6328C9.01125 1.71189 10.1516 2.13882 11.0956 2.86034C12.0396 3.58186 12.7451 4.56537 13.1244 5.68847C13.5038 6.81158 13.5398 8.02213 13.2279 9.16559C12.916 10.3091 12.2701 11.3328 11.3709 12.1101C10.4717 12.8873 9.35943 13.3816 8.17711 13.5308C6.99479 13.68 5.79653 13.4773 4.73199 12.9484" stroke={color} strokeWidth="1.16667" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

// ─── Category Config ──────────────────────────────────────────────────────────────
const CATEGORY_CONFIG = {
    "bid-request-validity": {
        themeClass: "theme-amber",
        icon: (color) => <BidRequestValidityIcon color={color || "#f59e0b"} />,
        iconColor: "#f59e0b",
    },
    "auction-eligibility": {
        themeClass: "theme-purple",
        icon: (color) => <AuctionEligibilityIcon color={color || "#8b5cf6"} />,
        iconColor: "#8b5cf6",
    },
    "monetization-readiness": {
        themeClass: "theme-green",
        icon: (color) => <MonetizationReadinessIcon color={color || "#10b981"} />,
        iconColor: "#10b981",
    },
    "optimization-signals": {
        themeClass: "theme-sky",
        icon: (color) => <OptimizationSignalsIcon color={color || "#0ea5e9"} />,
        iconColor: "#0ea5e9",
    },
    "optional-enhancements": {
        themeClass: "theme-rose",
        icon: (color) => <OptionalEnhancementsIcon color={color || "#f43f5e"} />,
        iconColor: "#f43f5e",
    },
    "device": {
        themeClass: "theme-sky",
        icon: (color) => <DeviceIcon color={color || "#0ea5e9"} />,
        iconColor: "#0ea5e9",
    },
    "criteria-type-missing-in-sheet": {
        themeClass: "theme-rose",
        icon: (color) => <CriteriaTypeIcon color={color || "#f43f5e"} />,
        iconColor: "#f43f5e",
    },
};

const DEFAULT_CONFIG = {
    themeClass: "theme-purple",
    icon: (color) => <AuctionEligibilityIcon color={color || "#8b5cf6"} />,
    iconColor: "#8b5cf6",
};

const EXPORT_FILE_URL = "https://unified-supply-platform.s3.ap-south-1.amazonaws.com/Helix_Health_Center_Knowledge_Article.docx"; // TODO: replace with actual docx URL

const handleExportDownload = () => {
    window.open(EXPORT_FILE_URL, "_blank");
};

// const EXPORT_API_ENDPOINT = "healthCenter/knowledge-base/export"; // TODO: confirm endpoint with backend
// const EXPORT_FILE_NAME = "knowledge-base.docx";

// const handleExportDownload = () => {
//     const token = Cookies.get("token_xapads_ssp");
//     if (!token) return;
//     axios
//         .get(configData.SERVER_URL + EXPORT_API_ENDPOINT, {
//             headers: { "x-access-token": token },
//             responseType: "blob",
//         })
//         .then((res) => {
//             const url = URL.createObjectURL(new Blob([res.data]));
//             const link = document.createElement("a");
//             link.href = url;
//             link.download = EXPORT_FILE_NAME;
//             document.body.appendChild(link);
//             link.click();
//             document.body.removeChild(link);
//             URL.revokeObjectURL(url);
//         })
//         .catch((err) => console.error("Export failed:", err));
// };

// ─── Component ──────────────────────────────────────────────────────────────────
const KnowledgeBase = () => {
    const location = useLocation();
    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(true);
    const [activeCategoryId, setActiveCategoryId] = useState(null);
    const [activeArticleId, setActiveArticleId] = useState(null);
    const [showDetail, setShowDetail] = useState(false);
    const articleRefs = useRef({});
    const categoryHeaderRefs = useRef({});

    useEffect(() => {
        TokenVerificationLoggedin();
        BlockAdmin()
        BlockAM()
        const token = Cookies.get("token_xapads_ssp");
        if (!token) return;
        axios
            .get(configData.SERVER_URL + "healthCenter/knowledge-base", {
                headers: { "Content-Type": "application/json", "x-access-token": token },
            })
            .then((res) => {
                if (res.data.success) {
                    const cats = res?.data?.knowledgeBase?.categories || [];
                    setCategories(cats);
                }
                else {
                    notifyfailure("Failed to fetch Knowledge Base Data")
                }
            })
            .catch((err) => {
                console.error("KnowledgeBase API error:", err);
            })
            .finally(() =>
                setTimeout(() => { setLoading(false) }, 500)
            );
    }, []);

    // Auto-select article from URL ?article= param once categories are loaded
    useEffect(() => {
        if (!categories.length) return;
        const params = new URLSearchParams(location.search);
        const articleParam = params.get("article");
        if (!articleParam) return;
        for (const cat of categories) {
            const found = cat.articles?.find((a) => a.title === articleParam);
            if (found) {
                setActiveCategoryId(cat.id);
                setActiveArticleId(found.id);
                setShowDetail(true);
                break;
            }
        }
    }, [categories, location.search]);

    // Scroll sidebar: to active article (when detail is open) or to category header (when opening accordion)
    useEffect(() => {
        const id = setTimeout(() => {
            if (showDetail && activeArticleId) {
                articleRefs.current[activeArticleId]?.scrollIntoView({ block: "nearest", behavior: "smooth" });
            } else if (!showDetail && activeCategoryId) {
                categoryHeaderRefs.current[activeCategoryId]?.scrollIntoView({ block: "start", behavior: "smooth" });
            }
        }, 50); // small delay lets Ant Design expand the panel first
        return () => clearTimeout(id);
    }, [activeCategoryId, activeArticleId, showDetail]);

    const selectedCategory = categories.find((c) => c.id === activeCategoryId) || categories[0] || null;
    const selectedArticle = selectedCategory?.articles?.find((a) => a.id === activeArticleId) || null;
    const categoryConfig = CATEGORY_CONFIG[selectedCategory?.id] || DEFAULT_CONFIG;

    if (loading) {
        return (
            <>
                <div className="container_box--wrapper pt_header">
                    <div className="container_box--wrapper--title d_flex justify-content-between">
                        <h1 className="heading fw_600">
                            Knowledge Base
                            {/* <span className="light_weight_text">File Upload</span> */}
                        </h1>

                    </div>
                    <div className='loader_top_space d-flex align-items-center justify-content-center'>
                        <div className="inside_table_two_loader">
                            <img src={FullLoader} className="" alt="" />
                        </div>
                    </div>
                </div>
            </>
        );
    }

    if (!categories.length) {
        return <div className="container_box--wrapper pt_header"><p style={{ padding: "2rem" }}>No data available.</p></div>;
    }

    const handleCategoryChange = (key) => {
        const newKey = Array.isArray(key) ? key[0] : key;
        setActiveCategoryId(newKey || null);
        setActiveArticleId(null);
        setShowDetail(false);
    };

    const handleArticleClick = (article, categoryId) => {
        setActiveCategoryId(categoryId);
        setActiveArticleId(article.id);
        setShowDetail(true);
    };

    const handleCardClick = (article, categoryId) => {
        setActiveCategoryId(categoryId);
        setActiveArticleId(article.id);
        setShowDetail(true);
    };

    const handleBackClick = () => {
        setShowDetail(false);
        setActiveArticleId(null);
    };

    const bestPractice = selectedArticle?.bestPractices?.find((bp) => bp.title === "Best Practice");
    const howToFix = selectedArticle?.bestPractices?.find((bp) => bp.title === "How to Fix");

    return (
        <div className="container_box--wrapper pt_header">
            <div className="container_box--wrapper--title d-flex align-items-center justify-content-between">
                <div className="back_btn_d2">
                    <h1 className="heading">
                        Knowledge Base
                        {/* <span className="light_weight_text">File Upload</span> */}
                    </h1>
                </div>
                <div className="searchbar_with_btns p-0">
                    <div className="export_btn_hover_d2">
                        <Button
                            className="export_btn_d2"
                            onClick={handleExportDownload}
                            icon={
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                    <path d="M12.25 8.75V11.0833C12.25 11.3928 12.1271 11.6895 11.9083 11.9083C11.6895 12.1271 11.3928 12.25 11.0833 12.25H2.91667C2.60725 12.25 2.3105 12.1271 2.09171 11.9083C1.87292 11.6895 1.75 11.3928 1.75 11.0833V8.75" stroke="#1E293B" strokeWidth="1.54" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M4.08423 5.83325L7.0009 8.74992L9.91756 5.83325" stroke="#1E293B" strokeWidth="1.54" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M7 8.75V1.75" stroke="#1E293B" strokeWidth="1.54" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            }
                        >
                            Export
                        </Button>
                    </div>
                </div>
            </div>

            <div className="side_bar_with_content">
                {/* ── Sidebar ── */}
                <aside className="knowledge_base_sidebar">
                    <Collapse
                        accordion
                        activeKey={activeCategoryId}
                        onChange={handleCategoryChange}
                        expandIcon={() => (
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                <path d="M5 7.5L10 12.5L15 7.5" stroke="#94A3B8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        )}
                        expandIconPosition="end"
                        className="knowledge_base_sidebar_accordion"
                        items={categories.map((category) => {
                            const cfg = CATEGORY_CONFIG[category.id] || DEFAULT_CONFIG;
                            return {
                                key: category.id,
                                label: (
                                    <div
                                        ref={(el) => { categoryHeaderRefs.current[category.id] = el; }}
                                        className={`sidebar_group_title ${cfg.themeClass}`}
                                    >
                                        <span className="sidebar_group_icon">{cfg.icon(cfg.iconColor)}</span>
                                        <span>{category.name?.toUpperCase()}</span>
                                    </div>
                                ),
                                children: (
                                    <div className="sidebar_link_list">
                                        {category.articles.map((article) => {
                                            const isActive = activeArticleId === article.id && activeCategoryId === category.id;
                                            return (
                                                <div
                                                    key={article.id}
                                                    ref={(el) => { articleRefs.current[article.id] = el; }}
                                                    className={`sidebar_link_item ${isActive ? "is-active" : ""}`}
                                                    onClick={() => handleArticleClick(article, category.id)}
                                                >
                                                    <span className="sidebar_link_item_label">{article.title}</span>
                                                    {/* {isActive && showDetail && (
                                                        <span
                                                            className="sidebar_back_arrow"
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                handleBackClick();
                                                            }}
                                                            title="Go back"
                                                        >
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 16 16" fill="none">
                                                                <path d="M12.667 8L3.33366 8" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                                                                <path d="M8 12.6667L3.33333 8.00008L8 3.33342" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                                                            </svg>
                                                        </span>
                                                    )} */}
                                                </div>
                                            );
                                        })}
                                    </div>
                                ),
                            };
                        })}
                    />
                </aside>

                {/* ── Cards Grid ── */}
                <div className={`knowledge_base_content${showDetail ? " d-none" : ""}`}>
                    {(activeCategoryId ? [selectedCategory].filter(Boolean) : categories).map((category) => {
                        const cfg = CATEGORY_CONFIG[category.id] || DEFAULT_CONFIG;
                        return (
                            <section className="knowledge_base_section" key={category.id}>
                                <div className="knowledge_base_section_header">
                                    <div className="knowledge_base_section_title_wrap">
                                        <span className={`knowledge_base_section_marker ${cfg.themeClass}`}>
                                            {cfg.icon(cfg.iconColor)}
                                        </span>
                                        <h2>{category.name?.toUpperCase()}</h2>
                                    </div>
                                    <hr className="horiz_line_design" />
                                    <span className="knowledge_base_section_count">
                                        {category.articles.length} conditions
                                    </span>
                                </div>

                                <div className="knowledge_base_card_grid">
                                    {category.articles.map((article) => (
                                        <article
                                            className="knowledge_base_card"
                                            key={article.id}
                                            onClick={() => handleCardClick(article, category.id)}
                                        >
                                            <div className="knowledge_base_card_header">
                                                <h3>{article.title}</h3>
                                                <span className="knowledge_base_card_icon">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                        <path d="M3.33301 8H12.6663" stroke="#64748B" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                                                        <path d="M8 3.33325L12.6667 7.99992L8 12.6666" stroke="#64748B" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                                                    </svg>
                                                </span>
                                            </div>
                                            <p>{article.shortDescription}</p>
                                        </article>
                                    ))}
                                </div>
                            </section>
                        );
                    })}
                </div>

                {/* ── Detail Panel ── */}
                <div className={`child_result_div${showDetail ? "" : " d-none"}`}>
                    {showDetail && selectedArticle && (
                        <div className="child_result_panel">
                            {/* Breadcrumb */}
                            <div className="child_result_breadcrumb">
                                <span
                                    className="back_arrow_btn_icon"
                                    style={{ cursor: "pointer" }}
                                    onClick={handleBackClick}
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                        <path d="M12.667 8L3.33366 8" stroke="#64748B" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M8 12.6667L3.33333 8.00008L8 3.33342" stroke="#64748B" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </span>
                                <span>Knowledge Base</span>
                                <span className="child_result_breadcrumb_arrow">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                        <path d="M5.25 10.5L8.75 7L5.25 3.5" stroke="#94A3B8" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </span>
                                <span className={`child_result_breadcrumb_current ${categoryConfig.themeClass}`}>
                                    {selectedCategory?.name}
                                </span>
                                <span className="child_result_breadcrumb_arrow">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                        <path d="M5.25 10.5L8.75 7L5.25 3.5" stroke="#94A3B8" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </span>
                                <span className="last_span">{selectedArticle.title}</span>
                            </div>

                            {/* Category badge */}
                            <div className={`child_result_meta ${categoryConfig.themeClass}`}>
                                <span className="child_result_meta_icon">
                                    {categoryConfig.icon(categoryConfig.iconColor)}
                                </span>
                                <span className="child_result_meta_text">
                                    {selectedCategory?.name?.toUpperCase()}
                                </span>
                            </div>

                            {/* Title */}
                            <div className="child_result_heading_block">
                                <h2>{selectedArticle.title}</h2>
                            </div>

                            {/* Description */}
                            <div className="child_result_description">
                                <span className="child_result_label">DESCRIPTION</span>
                                <p>{selectedArticle.description}</p>
                            </div>

                            {/* 3 Panels: Best Practice | How to Fix | Tags */}
                            <div className="child_result_three_panels">
                                {/* Best Practice */}
                                <div className="child_result_panel_card">
                                    <div className="child_result_panel_card_header">
                                        <span className={`child_result_panel_card_dot ${categoryConfig.themeClass}`} />
                                        <span className="child_result_label --new_text_cls">BEST PRACTICE</span>
                                    </div>
                                    <p className="child_result_panel_card_text --new_p_text_cls">
                                        {bestPractice?.description || "—"}
                                    </p>
                                </div>

                                {/* How to Fix */}
                                <div className="child_result_panel_card">
                                    <div className="child_result_panel_card_header">
                                        <span className={`child_result_panel_card_dot ${categoryConfig.themeClass}`} />
                                        <span className="child_result_label --new_text_cls">HOW TO FIX</span>
                                    </div>
                                    <p className="child_result_panel_card_text --new_p_text_cls">
                                        {howToFix?.description || "—"}
                                    </p>
                                </div>

                                {/* Tags */}
                                <div className="child_result_panel_card">
                                    <div className="child_result_panel_card_header">
                                        <span className={`child_result_panel_card_dot ${categoryConfig.themeClass}`} />
                                        <span className="child_result_label --new_text_cls">TAGS</span>
                                    </div>
                                    <div className="child_result_panel_tags">
                                        {selectedArticle.technicalDetails?.tags?.length > 0 ? (
                                            selectedArticle.technicalDetails?.tags.map((tag) => (
                                                <span key={tag} className={`child_result_panel_tag ${categoryConfig.themeClass}`}>
                                                    {tag}
                                                </span>
                                            ))
                                        ) : (
                                            <span className="child_result_panel_card_text --new_p_text_cls">—</span>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default KnowledgeBase;
